module.exports = __webpack_public_path__ + "img/bluesky3100_16.e0b66dae.jpg";